"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenu = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _useDefault3 = require("../_utils/hooks/useDefault");
var _MenuContext = require("./MenuContext");
var _MenuItem = require("./MenuItem");
var _isChildOfType = require("../_utils/isChildOfType");
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _excluded = ["title", "icon", "children", "defaultOpened", "opened", "onOpenedChange", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function hasSelectedItem(children) {
  var hasSelected = false;
  _react.default.Children.forEach(children, function (child) {
    if ((0, _isChildOfType.isChildOfType)(child, _MenuItem.MenuItem) && child.props.selected) {
      hasSelected = true;
    }
  });
  return hasSelected;
}
var SubMenu = exports.SubMenu = /*#__PURE__*/(0, _react.forwardRef)(function SubMenu(props, ref) {
  var _classNames;
  var defaultDefaultOpened = (0, _react.useMemo)(function () {
    return hasSelectedItem(props.children);
  }, [] // eslint-disable-line react-hooks/exhaustive-deps
  );
  var title = props.title,
    icon = props.icon,
    children = props.children,
    _props$defaultOpened = props.defaultOpened,
    defaultOpened = _props$defaultOpened === void 0 ? defaultDefaultOpened : _props$defaultOpened,
    _opened = props.opened,
    _onOpenedChange = props.onOpenedChange,
    className = props.className,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classPrefix = (0, _usePrefixCls.usePrefixCls)('menu');

  // 包含 tag 的子菜单项
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    tags = _useState2[0],
    setTags = _useState2[1];
  // 子菜单被选中项
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    selectedId = _useState4[0],
    setSelectedId = _useState4[1];
  var _useContext = (0, _react.useContext)(_MenuContext.MenuContext),
    collapsed = _useContext.collapsed;

  // eslint-disable-next-line no-param-reassign
  var _useDefault = (0, _useDefault3.useDefault)(
    // @ts-ignore
    _opened, defaultOpened, _onOpenedChange),
    _useDefault2 = (0, _slicedToArray2.default)(_useDefault, 2),
    opened = _useDefault2[0],
    onOpenedChange = _useDefault2[1];
  var _ref = Array.isArray(icon) ? icon : [icon, icon],
    _ref2 = (0, _slicedToArray2.default)(_ref, 2),
    defaultIcon = _ref2[0],
    activeIcon = _ref2[1];
  return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({
    ref: ref,
    className: (0, _classnames.default)("".concat(classPrefix, "-menu__submenu"), className, (_classNames = {}, (0, _defineProperty2.default)(_classNames, "".concat(classPrefix, "-menu__subbadge"), tags.length && !opened), (0, _defineProperty2.default)(_classNames, "is-selected", !!selectedId && (collapsed || !opened)), (0, _defineProperty2.default)(_classNames, "is-expanded", opened), _classNames))
  }, restProps), /*#__PURE__*/_react.default.createElement("a", {
    className: "".concat(classPrefix, "-menu__item"),
    onClick: function onClick() {
      return onOpenedChange(!opened);
    }
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: "".concat(classPrefix, "-menu__item-icon"),
    name: "direction-top"
  }), defaultIcon && (typeof defaultIcon === "string" ? /*#__PURE__*/_react.default.createElement("img", {
    className: "".concat(classPrefix, "-menu__list-icon"),
    src: defaultIcon,
    alt: "icon"
  }) : defaultIcon), activeIcon && (typeof activeIcon === "string" ? /*#__PURE__*/_react.default.createElement("img", {
    className: "".concat(classPrefix, "-menu__list-icon is-selected"),
    src: activeIcon,
    alt: "icon"
  }) : activeIcon), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classPrefix, "-menu__text")
  }, title)), /*#__PURE__*/_react.default.createElement("ul", {
    className: "".concat(classPrefix, "-menu__list")
  }, /*#__PURE__*/_react.default.createElement(_MenuContext.SubMenuContext.Provider, {
    value: {
      inSubMenu: true,
      onTagChange: function onTagChange(id, hasTag) {
        return setTags(function (tags) {
          if (hasTag) {
            return [].concat((0, _toConsumableArray2.default)(tags), [id]);
          }
          return tags.filter(function (i) {
            return i !== id;
          });
        });
      },
      onSelectedChange: function onSelectedChange(id, selected) {
        return setSelectedId(function (selectedId) {
          if (selected) {
            return id;
          }
          if (id === selectedId) {
            return null;
          }
          return selectedId;
        });
      }
    }
  }, children)));
});
SubMenu.displayName = "SubMenu";